import { PropsWithChildren } from 'react';

import styles from './Loadable.module.scss';

export function Loadable({
  loading,
  children,
}: PropsWithChildren<{ loading: boolean }>): JSX.Element {
  // TODO: add some loading icons here (earlier react-loader-spinner was used)
  return loading ? (
    <div className={styles.overlay}>Loading</div>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
}
